module.exports = __webpack_public_path__ + "img/img73.8f6dd7d1.png";